import { render } from "./Content.vue?vue&type=template&id=62c9e0fe&scoped=true"
const script = {}

import "./Content.vue?vue&type=style&index=0&id=62c9e0fe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-62c9e0fe"

export default script